import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Avatar from '@mui/material/Avatar';
import MenuItem from '@mui/material/MenuItem';
import Popover from '@mui/material/Popover';
import { Link } from 'react-router-dom';
import { Person } from '@mui/icons-material';

import person from "src/Assets/iconography/person.svg";
import settings from "src/Assets/iconography/settings.svg";
import iconLogout from "src/Assets/iconography/logout.svg";
import iconLogoutWhite from "src/Assets/iconography/logout_white.svg";

import { logout } from '../../reducers/sessionSlice';
import DeleteModal from '../DeleteModal';
import { socket } from 'src/socket';
import { disconnect } from "src/reducers/socketSlice";

function UserMenu( { textWhite = false }) {

    const dispatch = useDispatch();
    const history = useHistory();
    const session = useSelector((state) => state.session);

    const [userMenu, setUserMenu] = useState(null);
    const [modal, setModal] = useState(false);

    const userMenuClick = (event) => {
        setUserMenu(event.currentTarget);
    };


    const userMenuClose = () => {
        setUserMenu(null);
    };

    const logoutUser = () => {
        //Socket
        socket.disconnect();
        dispatch(disconnect());
        dispatch(logout())
        history.push("/");
    };
    let role = '';
    if(session.user.role == 'client'){
        role = 'Cliente'
    } else if(session.user.role == 'member'){
        role = 'Integrante'
    } else if(session.user.role == 'collaborator'){
        role = 'Colaborador'
    } else {
        role = session.user.jobOcuppation;
    }
    return (
        <>
            <button
                onClick={userMenuClick}
                className="flex text-base rounded-full items-center"
            >
                <Avatar
                    sx={{ width: { xs: 36, sm: 50 }, height: { xs: 36, sm: 50 }, backgroundColor:'#d1d5db'}}
                    src={session.user?.photo?.fileURL}
                    alt={session.user?.name}
                >
                    <Person
                        sx={{ width: 30, height: 30 }}
                    />
                </Avatar>
                <div className="hidden sm:flex flex-col justify-center mx-4 items-start">
                    <p
                        className={`${textWhite ? 'text-white' : 'text-black'} text-medium flex text-base`}
                    >
                        { session.user?.name } { session.user?.lastName }
                    </p>

                    <div className='flex'>
                        <div className='flex'>
                            <span
                                className="w-2.5 h-2.5 mr-1 mt-0.5 text-xs font-medium rounded-full"
                                style={{backgroundColor: socket.connected ? '#38ab3e' : '#d32f2f' }}
                            />
                            <p
                                className={`${textWhite ? 'text-white' : 'text-black'} text-light capitalize text-base -mt-1`}
                            >
                                { role  ?  role : '---'}
                               
                            </p>
                        </div>
                        {session.user?.companyName&&
                            <p
                                className={`${textWhite ? 'text-white' : 'text-black'} text-light flex text-base -mt-1 mx-1`}
                            >
                                - { session.user?.companyName }
                            </p>
                        }
                    </div>
                </div>
            </button>
            <Popover
                open={Boolean(userMenu)}
                anchorEl={userMenu}
                onClose={userMenuClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                classes={{
                    paper: 'py-4',
                }}
            >
                <MenuItem component={Link} to="/profile" onClick={userMenuClose} role="button">
                    <img
                        src={person}
                        alt=""
                        className="w-3 h-auto mx-2"
                    />
                    <p className="text-base text-bold flex text-blue">
                        Mi Perfil
                    </p>
                </MenuItem>
                <MenuItem component={Link} to="/profile/account" onClick={userMenuClose} role="button">
                    <img
                        src={settings}
                        alt=""
                        className="w-4 h-auto mx-2"
                    />
                    <p className="text-base text-bold flex text-blue">
                        Configuración
                    </p>
                </MenuItem>
                <MenuItem
                    onClick={()=>{
                        setModal(true);
                    }}
                >
                    <img
                        src={iconLogout}
                        alt=""
                        className="w-4 h-auto mx-2"
                    />
                    <p className="text-base text-bold flex text-blue">
                        Cerrar Sesión
                    </p>
                </MenuItem>
            </Popover>

            <DeleteModal
                title="Estás a punto de Cerrar Sesión"
                subTitle="¿Estás seguro de salir?"
                cancelTitle="Cancelar"
                acceptTitle="Salir"
                actionAccept={logoutUser}
                open={modal}
                setOpen={setModal}
                icon={iconLogoutWhite}
            />
        </>
    );
}

export default UserMenu;
